import React from 'react';

import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/default/button';
import Field from '@atlaskit/form/field';
import Form from '@atlaskit/form/form';
import { FormFooter } from '@atlaskit/form/form-footer';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import TextField from '@atlaskit/textfield/text-field';

const FormFieldExample = (): React.JSX.Element => (
	<Flex direction="column">
		<Form onSubmit={(data) => console.log('form data', data)}>
			<>
				<Field
					name="username"
					defaultValue=""
					label="Username"
					isRequired
					helperMessage="Your username can have up to 16 characters."
					validMessage="Username is valid."
					validate={(value) => {
						if (!value) {
							return 'Username is required.';
						} else if (value && value.length > 16) {
							return 'Username must be 16 characters or less.';
						}
					}}
					component={({ fieldProps }) => <TextField {...fieldProps} />}
				/>
				<FormFooter align="start">
					<ButtonGroup label="Form submit options">
						<Button type="submit" appearance="primary">
							Submit
						</Button>
						<Button appearance="subtle">Cancel</Button>
					</ButtonGroup>
				</FormFooter>
			</>
		</Form>
	</Flex>
);

export default FormFieldExample;
